// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1TIzG","footer":"ModalInfo_footer__f_eG3"};